/* eslint-disable no-unused-vars */
import React, { useReducer, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { LOAD_THEME, UPDATE_LOGO, UPDATE_THEME } from './constants';
import { ThemeContext } from './themeContext';
import { themeReducer } from './themeReducer';
import { init, storeThemeData } from '../../utils/theme';
import defaultTheme from '../../theme/defaultTheme';
import { createLogoConfiguration, createPaletteConfiguration } from './utils';

const DEFAULT_THEME = {
  theme: defaultTheme,
  logo: {},
  disableLogo: true,
};

export const ThemeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(themeReducer, DEFAULT_THEME, init);

  const updateTheme = useCallback((payload) => {
    dispatch({ type: UPDATE_THEME, payload });
  }, []);

  const updateLogo = useCallback((payload) => {
    dispatch({ type: UPDATE_LOGO, payload });
  }, []);

  const loadTheme = useCallback(async (company, token) => {
    const logoTheme = await createLogoConfiguration(company, token);
    const newTheme = await createPaletteConfiguration(defaultTheme, company, token);
    storeThemeData({ theme: newTheme, ...logoTheme });
    dispatch({ type: LOAD_THEME, payload: { ...logoTheme, theme: newTheme } });
  }, [createLogoConfiguration, createPaletteConfiguration]);

  const value = useMemo(() => ({
    state,
    updateTheme,
    updateLogo,
    loadTheme,
  }), [state, updateTheme, updateLogo, loadTheme]);

  return (
    <ThemeContext.Provider
      value={value}
    >
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
